import { useCallback } from "react";

import { IDropdownItemStations, useSystemParams } from "@ryde/shared";

import {
  IDropdownCustomTransformationsFn,
  IDropdownCustomTransformationsFnResponse,
  IDropdownCustomTransformationsProps,
} from "../models";

export const usePassengerSourceStation2OfficialFilterTransformerFn = (): {
  passengerSourceStation2OfficialFilterTransformerFn: IDropdownCustomTransformationsFn;
} => {
  const { showSpecialStationInSource2 } = useSystemParams();

  const passengerSourceStation2OfficialFilterTransformerFn = useCallback(
    ({
      dropdownItems,
    }: IDropdownCustomTransformationsProps): IDropdownCustomTransformationsFnResponse => {
      if (showSpecialStationInSource2 !== true) {
        return dropdownItems;
      }

      return dropdownItems?.filter(item => {
        return (item as IDropdownItemStations).isOfficial;
      });
    },
    [showSpecialStationInSource2],
  );

  return { passengerSourceStation2OfficialFilterTransformerFn };
};
